import React from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import { faCamera } from "@fortawesome/free-solid-svg-icons"

import Icon from "../../../layout/icon"
import { container } from "./styles.module.scss"

const PhotoCount = ({ count, className }) => (
  <div className={classNames(container, className)}>
    <Icon icon={faCamera} />
    {count}
  </div>
)

PhotoCount.propTypes = {
  count: PropTypes.number.isRequired,
  className: PropTypes.string,
}

PhotoCount.defaultProps = {
  className: undefined,
}

export default PhotoCount
